import DataDisplayRowI from "../DataDisplayRowI";
import getAllTransactionRow from "../DataDisplayRow/AllTransactionRow";
import getCashTransactionRow from "../DataDisplayRow/CashTransactionRow";
import getCoinsTransactionRow from "../DataDisplayRow/CoinsTransactionRow";
import DataDisplayTable from "../DataDisplayTable";

export enum TransactionTypes {
    ALL = "all",
    CASH = "cash",
    COINS = "coins",
}

class AllTransactionTable extends DataDisplayTable {
    #row!: DataDisplayRowI

    generateRow(type: TransactionTypes): DataDisplayRowI {
        let errMesssage = "Type must be of TransactionTypes: "
        Object.keys(TransactionTypes).forEach((key) => errMesssage += `${key}|`)
        errMesssage = errMesssage.slice(0, errMesssage.length - 1)
        if (!type)
            throw new TypeError(errMesssage)
        switch (type) {
            case TransactionTypes.ALL:
                this.#row = getAllTransactionRow()
                break;
            case TransactionTypes.CASH:
                this.#row = getCashTransactionRow()
                break;
            case TransactionTypes.COINS:
                this.#row = getCoinsTransactionRow()
                break;
            default:
                throw new TypeError(errMesssage)
        }
        return this.#row!!
    }
}

let allTransactionTable: AllTransactionTable | null = null;

export default function getTransactionTable(): AllTransactionTable {
    if (allTransactionTable === null)
        allTransactionTable = new AllTransactionTable()
    return allTransactionTable
}